//color constants
export const primaryColor = '#4f30b3';
export const secondaryColor = '#ecebe4';
export const sourceColor = 'rgba(255,0,0,0.5)';
export const destinationColor = 'rgba(0,255,0,0.5)';

//font-family
export const ubuntu = "'Ubuntu', sans - serif";
